/* tslint:disable */
/* eslint-disable */
/**
 * Atelier Roles API
 * L\'Atelier des rôles (BO admin) : référentiel des briques (standard verrouillées, personnalisées administrables), profils (ensembles de rôles appliqués à la création des acteurs) et matrice rôles/portails. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NatureProfilDto
 */
export interface NatureProfilDto {
    /**
     * 
     * @type {string}
     * @memberof NatureProfilDto
     */
    nature: string;
    /**
     * 
     * @type {string}
     * @memberof NatureProfilDto
     */
    libelle?: string | null;
    /**
     * Sous-nature du mapping ("" = variant par défaut de la nature).
     * @type {string}
     * @memberof NatureProfilDto
     */
    sousNature?: string;
    /**
     * 
     * @type {string}
     * @memberof NatureProfilDto
     */
    profilId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NatureProfilDto
     */
    profilNom?: string | null;
}

/**
 * Check if a given object implements the NatureProfilDto interface.
 */
export function instanceOfNatureProfilDto(value: object): value is NatureProfilDto {
    if (!('nature' in value) || value['nature'] === undefined) return false;
    return true;
}

export function NatureProfilDtoFromJSON(json: any): NatureProfilDto {
    return NatureProfilDtoFromJSONTyped(json, false);
}

export function NatureProfilDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NatureProfilDto {
    if (json == null) {
        return json;
    }
    return {
        
        'nature': json['nature'],
        'libelle': json['libelle'] == null ? undefined : json['libelle'],
        'sousNature': json['sousNature'] == null ? undefined : json['sousNature'],
        'profilId': json['profilId'] == null ? undefined : json['profilId'],
        'profilNom': json['profilNom'] == null ? undefined : json['profilNom'],
    };
}

export function NatureProfilDtoToJSON(json: any): NatureProfilDto {
    return NatureProfilDtoToJSONTyped(json, false);
}

export function NatureProfilDtoToJSONTyped(value?: NatureProfilDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nature': value['nature'],
        'libelle': value['libelle'],
        'sousNature': value['sousNature'],
        'profilId': value['profilId'],
        'profilNom': value['profilNom'],
    };
}

